import { authInstance, noAuthInstance } from './axios/index';
import qs from 'qs';

const notificationService = {
  // 내 알림 목록 조회
  getMyNotificationList: (params) => {
    // /api/notification/v1/push-notification/my/notifications
    const requestOptions = {
      method: 'GET',
      url: `/api/notification/v1/push-notification/my/notifications?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  //내 알림 목록 조회 (채팅만)
  getMyNotificationChat: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/notification/v1/push-notification/my/chat/notifications?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 내 알림 확인(읽음) 처리
  checkNotification: (manageId, userNo) => {
    const requestOptions = {
      method: 'PATCH',
      url: `/api/notification/v1/push-notification/${manageId}/user/${userNo}/check`,
    };
    return authInstance(requestOptions);
  },
  // 내 알림 그룹 확인(읽음) 처리
  checkNotificationGroup: (params) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/notification/v1/push-notification/my/notifications/check-group-chat?${qs.stringify(
        params,
        {
          arrayFormat: 'repeat',
        },
      )}`,
    };
    return authInstance(requestOptions);
  },
  // 메시지 로그 등록
  createMessageLog: (data) => {
    const requestOptions = {
      method: 'POST',
      url: `/api/notification/v1/message-log`,
      data: JSON.stringify(data),
    };
    return noAuthInstance(requestOptions);
  },
  //미확인 채팅 그룹 조회
  getUncheckedNotificationGroup: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/notification/v1/push-notification/my/chat/notifications/group?${qs.stringify(
        params,
      )}`,
    };
    return authInstance(requestOptions);
  },
  //미확인 채팅 카운트
  getUncheckGroupCount: (params) => {
    const requestOptions = {
      method: 'GET',
      url: `/api/notification/v1/push-notification/my/chat/notifications/uncheck-group-count?${qs.stringify(
        params,
      )}`,
    };
    return authInstance(requestOptions);
  },
};

export default notificationService;
